import RequireAuthWithToken from 'auth/components/RequireAuthWithToken';
import OverlayLoader from 'core-lib/components/OverlayLoader';
import { CLOSE_SCREEN_EVENT } from 'core-lib/constants/nativeBridge';
import { PLATFORM } from 'core-lib/data/common';
import { checkMobileOS } from 'core-lib/utils/helpers';
import { passMessageToNative } from 'core-lib/utils/nativeBridge';
import { useRouter } from 'next/router';
import { useEffect } from 'react';
import { AppBar } from 'ui-v2/components/AppBar';
import { handleVoucherRedirection, VoucherScreenId } from 'ui-v2/utils';

const Overlay = () => {
  return (
    <>
      <AppBar zIndex={11} />
      <OverlayLoader styleProp={{ backgroundColor: '#fff' }} />
    </>
  );
};

const VouchersRedirectPage = () => {
  const router = useRouter();
  const { brandSlug } = router.query || {};

  useEffect(() => {
    if (brandSlug) {
      handleVoucherRedirection({
        screenId: VoucherScreenId.BuyVoucherScreen,
        query: { brand_slug: brandSlug },
        callback_script: `window?.JSBridge?.fireJavaScriptEvent('closeScreen',null,null);
         window?.webkit?.messageHandlers?.fireJavaScriptEvent?.postMessage('closeScreen');`,
      });
      if (checkMobileOS() === PLATFORM.android) {
        passMessageToNative(CLOSE_SCREEN_EVENT);
      }
    }
  }, [brandSlug]);

  return <Overlay />;
};

const FinalComp: any = RequireAuthWithToken(VouchersRedirectPage);

export default FinalComp;

FinalComp.getInitialProps = ({ query, pathname, asPath }) => ({
  SkeletonLoader: Overlay,
  query,
  pathname,
  asPath,
});
